<script>
    import {
        formatEventDate,
        formatEventTime,
        isSameDay,
    } from "../util/date.js";
    import { formatEventTimeDate, formatLongEventDate } from "../util/date";

    export let startDate;
    export let endDate;
    export let isHeadline = false;

    export let showTime = true;
</script>


{#if isSameDay(startDate, endDate)}
    {#if isHeadline}
        <div class="headline-l grey-headline">
            {formatLongEventDate(startDate)},
        </div>
        {#if showTime}
            <div class="headline-l grey-headline">
                {formatEventTimeDate(startDate, endDate)}
            </div>
        {/if}
    {:else}
        <div class="text-m">
            {formatEventDate(startDate)}
            {#if showTime}
                {formatEventTimeDate(startDate, endDate)}
            {/if}
        </div>
    {/if}
{:else if isHeadline}
    <div class="headline-l grey-headline">
        {formatEventDate(startDate)} bis <br />{formatEventDate(endDate)}
        {new Date(endDate).getFullYear()}
    </div>
{:else}
    <div class="text-m">
        {formatEventDate(startDate)} - {formatEventDate(endDate)}
        {new Date(endDate).getFullYear()}
    </div>
{/if}

<style>
    .grey-headline {
        color: var(--black-40);
        -webkit-font-smoothing: antialiased;
    }

    @media (min-width: 1440px) {
        .grey-headline {
            font-size: 48px;
        }
    }
</style>
